import { useQuery } from '@tanstack/react-query'
import { rqKeys } from '@/react-query-keys'
import { apiRequestNew } from '@/helpers/request'
import { getMs } from '@/helpers'
import type { T_DocsResponse } from '@/types/responses'

export const useDocuments = (categoryId?: string) => {
  const { data, isLoading } = useQuery<T_DocsResponse>({
    queryKey: [ rqKeys.documents, categoryId ],
    queryFn: () =>
      apiRequestNew(
        'GET',
        `/portal/article?path=information/docs/${categoryId}&fields=name,title,description,children,link,id`
      ),
    enabled: !!categoryId,
    staleTime: getMs('15m'),
    refetchOnWindowFocus: false,
  })

  return { data, isLoading }
}
